<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<template lang="pug">

  div

    div.c-auth-page__head
      h1 {{ $t('h1') }}
      h2 {{ $t('h2') }}

    form-confirmation

</template>

<script>
import { minLength, numeric, required } from 'vuelidate/lib/validators';

import formConfirmation from '../form-confirmation/component';

export default {
  data() {
    return {
      model: {
        phoneCode: this.$store.state.registration.phoneCode,
        phoneNumber: this.$store.state.registration.phoneNumber,
      },
    };
  },

  components: {
    formConfirmation,
  },

  validations: {
    model: {
      phoneCode: {
        required,
        numeric,
        minLength: minLength(1),
      },
      phoneNumber: {
        required,
        numeric,
        minLength: minLength(10),
      },
    },
  },

  mounted() {
    if (this.$route.params._route) {
      this.model.phoneCode = this.$route.params.phone_code;
      this.model.phoneNumber = this.$route.params.phone_number;
      this.$store.dispatch('registration/setPhoneCode', this.model.phoneCode);
      this.$store.dispatch('registration/setPhoneNumber', this.model.phoneNumber);
    }

    if (this.$v.$invalid) {
      this.$router.push({ name: 'enter-number' });
    }
  },
};
</script>
